import styled from "@emotion/styled/macro";
import { colors } from "../../../../common/styles/theme.styles";

export const PageWrapper = styled.div`
    position: relative;
    display: flex;
    padding: 45px 45px 24px 45px;
    flex-direction: column;
    align-items: flex-start;
    background-color: #f2f3f5;
    height: 100%;
    overflow: hidden;
`;

export const PageContent = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    gap: 0;
    overflow-y: auto;
    ${({ withPanel }) => withPanel && `
        gap: 16px;
    `}
`;

export const MainContent = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    min-width: 0;
    overflow-y: auto;
    position: relative;
`;

export const VaultSearchButton = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    min-width: 38px;
    height: 36px;
    border-radius: 12px;
    border: 1px solid #DDE3EB;
    background: #FFFFFF;
    cursor: pointer;
    margin-left: 8px;
    
    svg {
        width: 16px;
        height: 16px;
        
        circle, line {
            stroke: ${colors.darkGray1};
        }
    }
    
    &:hover {
        background: #F5F5F5;
    }
`;

export const VaultUploadButtonText = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
`;

export const VaultUploadDropdownMenu = styled.div`
    background: #595959;
    border-radius: 12px;
    box-shadow: 0 4px 24px rgba(0,0,0,0.18);
    padding: 0;
    min-width: 220px;
    overflow: hidden;
`;

export const VaultUploadDropdownMenuItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
    color: #fff;
    font-size: 16px;
    padding: 8px 16px;
    background: none;
    border: none;
    cursor: pointer;
    transition: background 0.15s;
    &:not(:last-of-type) {
        border-bottom: 1px solid ${colors.gray2};
    }
`;

export const VaultUploadDropdownMenuIcon = styled.span`
    color: #fff;
    font-size: 20px;
    display: flex;
    align-items: center;
`;